/**
 * bootstrap
 */
 try {
	if(!window.Popper) {
		window.Popper = require('popper.js').default;
	}
	if(!window.$) {
		window.$ = window.jQuery = require('jquery');
	}
  if (typeof bootstrap === 'undefined') {
    //const bootstrap = require('bootstrap');
  }
} catch (e) {}

/**
 * lodash
 */
 window._ = require('lodash');


/**
 * vue
 */
 import Vue from 'vue';
 window.Vue = Vue;

/**
 * vue-cookies
 */
 Vue.use(require('vue-cookies'));

/**
 * bootstrap vue
 */
 import BootstrapVue from 'bootstrap-vue';

 import 'bootstrap/dist/css/bootstrap.css'
 import 'bootstrap-vue/dist/bootstrap-vue.css'

 Vue.use(BootstrapVue);

/**
 * vee-validator
 */
 import VeeValidate from 'vee-validate';
 import VeeValidateLocaleJa from 'vee-validate/dist/locale/ja';

 VeeValidate.Validator.localize('ja', VeeValidateLocaleJa);
 Vue.use(VeeValidate, {
   locale: 'ja',
   // This is the default
  inject: true,
  // Important to name this something other than 'fields'
  fieldsBagName: 'veeFields',
  // This is not required but avoids possible naming conflicts
  errorBagName: 'veeErrors'
 });


/**
 * axios
 */
 window.axios = require('axios');

 window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

 //API cache disable
 window.axios.interceptors.request.use(function (config) {
   if (typeof config.params === 'undefined' || typeof config.params === null) {
     config.params = {};
   }
   if (typeof config.params === 'object') {
     if (typeof URLSearchParams === 'function' && config.params instanceof URLSearchParams) {
       config.params.append('_', Date.now());
     }
     else {
       config.params._ = Date.now();
     }
   }

   return config;
 });


/**
 * lodash
 */
 window._ = require('lodash');

 /**
  * moment
  */
 window.moment = require('moment');
 moment.locale('ja');


/**
 * uri.js
 */
 window.URI = require('urijs');


 /**
 * Vue Components
 */

Vue.component('login-form-component', require('../components/front/members/LoginFormComponent.vue').default);
Vue.component('register-form-component', require('../components/front/members/RegisterFormComponent.vue').default);
Vue.component('password-reset-form-component', require('../components/front/members/PasswordResetFormComponent.vue').default);
Vue.component('password-reset-request-form-component', require('../components/front/members/PasswordResetRequestFormComponent.vue').default);

Vue.component('header-toast-component', require('../components/front/shared/HeaderToastComponent.vue').default);
Vue.component('header-login-buttons-component', require('../components/front/shared/HeaderLoginButtonsComponent.vue').default);
Vue.component('header-login-message-component', require('../components/front/shared/HeaderLoginMessageComponent.vue').default);

Vue.component('members-list-component', require('../components/admin/members/ListComponent.vue').default);
Vue.component('members-detail-component', require('../components/admin/members/DetailComponent.vue').default);


/**
 * Vue app
 */

const app = new Vue({
    el: '#app'
});
